import type { Room } from 'livekit-client';

/**
 * ANA-408 — client → voice-agent idle "still there?" spoken check-in.
 *
 * ANA-407 surfaced the two-phase idle prompt (`useVoiceConversation.
 * idlePrompting`) in the UI, but it stayed silent — a user not looking at the
 * screen gets no signal before the phase-2 auto-pause. When phase 1 fires we
 * publish an `idle_check_in` data frame; the agent speaks a short canned line
 * directly (no n8n round-trip — this isn't a real turn). Event name + shape
 * mirror `agent/src/idle-check-in.ts` exactly.
 */
export const IDLE_CHECK_IN_EVENT = 'idle_check_in';

/**
 * Publish an `idle_check_in` frame to the agent. Returns `true` when it was
 * published, `false` when there's no live local participant or the publish
 * throws — the idle prompt itself still shows in the UI either way (ANA-407),
 * this is best-effort audio on top.
 */
export function publishIdleCheckIn(room: Room | null | undefined): boolean {
  if (!room?.localParticipant) return false;
  try {
    const payload = new TextEncoder().encode(JSON.stringify({ event: IDLE_CHECK_IN_EVENT }));
    void room.localParticipant.publishData(payload, { reliable: true });
    return true;
  } catch {
    return false;
  }
}
